<template>
  <div class="account-tab-content tab-qrcodes">
    <TableAccount
            :title="'QR Codes Created'"
            :fields="fields"
            :items="transactions"
            :current-page="currentPage"
            :total-rows="rows"
            :per-page="perPage"
            @changePage="handleChangePage"
    />
  </div>
</template>

<script>
import TableAccount from '@/components/common/table/table';
import accountService from '@/services/account.service';

export default {
  components: {
    TableAccount
  },
  data() {
    return {
      transactions: null,
      total: 0,
      perPage: 3,
      currentPage: 1,
      fields: [
        {key: 'created_at_short', label: 'Date Created'},
        {key: 'bets.bet.length', label: 'Ticket(s)'},
        {key: 'code', label: 'QR CODE'},
        {key: 'action', label: '', actions: [
            {
              'title': 'QR CODE',
              'action': 'handleResendQrCode',
              'value': 'code'
            }
          ]}
      ]
    }
  },
  computed: {
    rows() {
      return this.total
    }
  },
  created() {
    accountService.overview(this.currentPage).then((res) => {
      if (res) {
        this.transactions = res.qr;
        this.total = res.total;
      }
    });
  },
  methods: {
    handleChangePage(val) {
      this.currentPage = val;
      accountService.overview(this.currentPage).then((res) => {
        if (res) {
          this.transactions = res.qr;
        }
      });
    }
  }
}
</script>
